<footer class="footer">
    <div class="container container-full">
        <div class="footer-inner">
            <div class="footer-left">
                <div class="footer-logo-dv">
                    <a routerLink="/" title="Hungery home">
                        <img src="./assets/images/hungery-logo.png" alt="Hungery" class="img-fluid img-footer-logo" />
                    </a>
                </div>

                <div class="footer-social-dv">
                    <ul class="social-list">
                        <li> <a href="https://www.instagram.com/hungery.id" target="_blank" rel="noopener noreferrer" title="Hungery on Instagram"><img src="./assets/images/instagram.png" alt="Instagram" class="img-social img-instagram" /></a></li>
                        <li> <a href="https://www.tiktok.com/@hungery.ttid" target="_blank" rel="noopener noreferrer" title="Hungery on TikTok"><img src="./assets/images/tik-tok.png" alt="TikTok" class="img-social img-tiktok" /></a></li>
                        <li> <a href="https://www.linkedin.com/company/hungery" target="_blank" rel="noopener noreferrer" title="Hungery on LinkedIn"><img src="./assets/images/linkedin.png" alt="LinkedIn" class="img-social img-linkedin" /></a></li>
                    </ul>
                </div>

                <div class="app-store-link-group">
                    <a class="pointer" (click)="openModal(playstoreInfoModalComponent.playStoreTemplate, 'add-profile-modal');"><img src="./assets/images/play-store.png" alt="Get it on Google Play" title="Google play store" class="img-store img-play-store" /></a>
                    <a class="pointer" (click)="openModal(playstoreInfoModalComponent.playStoreTemplate, 'add-profile-modal');"><img src="./assets/images/apple-store.png" alt="Download on the App Store" title="App store" class="img-store img-apple-store" /></a>
                </div>
            </div>

            <div class="footer-right">
                <!-- These were all href="#" (scroll-to-top) although each page exists. -->
                <div class="footer-link-dv">
                    <ul class="link-list">
                        <li><a routerLink="/why-hungery">Why Hungery</a></li>
                        <li><a routerLink="/pricing">Pricing</a></li>
                        <li><a routerLink="/onboarding">Register for FREE</a></li>
                        <li><a routerLink="/get-in-touch">Get in Touch</a></li>
                    </ul>
                </div>
                <div class="footer-info-link-dv">
                    <ul class="link-list">
                        <li><a class="pointer" (click)="openModal(privacyPolicyModalComponent.privacyPolicyTemplate, 'edit-food-menu-modal');">Privacy</a></li>
                        <!-- Pages don't exist yet: stay visible but announce instead of
                             navigating to "#" (which scrolled to top). -->
                        <li><a ngbTooltip="Coming soon" tooltipClass="tooltip-custom">Terms</a></li>
                        <li><a ngbTooltip="Coming soon" tooltipClass="tooltip-custom">Disputes</a></li>
                    </ul>
                </div>
                <p>{{ year }} <a routerLink="/">HUNGERY</a> All rights reserved</p>
            </div>
        </div>
    </div>
</footer>
<app-playstore-info-modal #playStoreModal></app-playstore-info-modal>
<app-privacy-policy-modal #privacyPolicyModal></app-privacy-policy-modal>
